import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(1),
    backgroundColor: "#FFF",
    textAlign: "left",
  },
  mobileHeaders: {
    marginTop: "5px",
    marginBottom: "5px",
    fontSize: "12px",
    color: "#9A9A9A",
    textAlign: "center",
  },
}))

export default styles
